import { Modal } from "@general-backoffice/core/index";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";

import StatsSummaryCard from "../shared/StatsSummaryCard";

interface DiscountWalletCardProps {
  amount: number;
  unused: number;
  isLoading: boolean;
}

const DiscountWalletCard = ({ amount, unused, isLoading }: DiscountWalletCardProps) => {
  const { t } = useTranslation("referrer", { keyPrefix: "discountWalletCard" });
  const [isOpenModalInfo, setIsOpenModalInfo] = React.useState(false);

  const getNum = (num: number) => (!isLoading ? (num || 0).toFixed(2) : "--.--") + " €";

  const stats = [
    { title: t("usedSubtitle"), stat: getNum(amount - unused) },
    { title: t("unusedSubtitle"), stat: getNum(unused) },
  ];

  return (
    <>
      <Modal.Info titleInfo={t("infoTitle")} isOpen={isOpenModalInfo} toggleOpen={() => setIsOpenModalInfo(false)}>
        {t("infoText")}
      </Modal.Info>

      <StatsSummaryCard
        mainStat={<div className="text-success">{getNum(amount)}</div>}
        mainTitle={t("subtitle")}
        stats={stats}
        color="white"
        topRight={
          <Button
            className="h3 m-0 shadow-none ml-8"
            onClick={() => setIsOpenModalInfo(true)}
            aria-label={t("moreInfo")}
            title={t("moreInfo")}
          >
            <i className="fas fa-info-circle" aria-hidden="true" />
          </Button>
        }
      />
    </>
  );
};

export default DiscountWalletCard;
